import { SapReservationsAdd } from "../../features"

const SapReservationsAddPage = () => {
  return <SapReservationsAdd />
}

export default SapReservationsAddPage
